import { ModalCustom } from "components/ModalCustom";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalCertezaRemoverProcesso({ show, handleClose, onConfirm }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Remover processo"
      centered
      footer
      footerConfirmButton
      confirmButtonText="Remover"
      cancelButtonText="Cancelar"
      onConfirm={onConfirm}
      onCancel={handleClose}
    >
      <div style={{ textAlign: "center", padding: "8px 0" }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: "#fdecd3",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 12,
          }}
        >
          <FaExclamation style={{ color: "#fe8f14", fontSize: "1.8rem" }} />
        </div>
        <p style={{ marginBottom: 0 }}>
          Deseja remover o(s) processo(s) selecionado(s) deste lote de pagamento?
        </p>
      </div>
    </ModalCustom>
  );
}
